import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { GeneralConstants } from '../constants/general.constants';

@Injectable({
  providedIn: 'root'
})
export class CierreLoteService {
  constructor(private restService: RestService) {}

  public getResumenOperacionesPix(request: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.restService
        .post(GeneralConstants.getResumenOperaciones, request)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }
}
